'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// GoogleChartLoader Singleton
// Based on http://blog.arkency.com/2014/09/react-dot-js-and-google-charts/

var script = typeof window !== 'undefined' ? require('loadjs') : function (link, _ref) {
  var callback = _ref.success;
  return callback();
};

var GoogleChartLoader = function () {
  function GoogleChartLoader() {
    (0, _classCallCheck3.default)(this, GoogleChartLoader);

    this.isLoaded = false;
    this.isLoading = false;
    this.initPromise = {};
  }

  (0, _createClass3.default)(GoogleChartLoader, [{
    key: 'init',
    value: function init() {
      var _this = this;

      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$packages = _ref2.packages,
          packages = _ref2$packages === undefined ? ['corechart', 'bar', 'geochart'] : _ref2$packages,
          _ref2$version = _ref2.version,
          version = _ref2$version === undefined ? 'current' : _ref2$version,
          mapsApiKey = _ref2.mapsApiKey;

      if (this.isLoading || this.isLoaded) {
        return this.initPromise;
      }
      this.isLoading = true;

      this.initPromise = new _promise2.default(function (resolve) {
        script('https://www.gstatic.com/charts/loader.js', {
          success: function success() {
            window.google.charts.load(version, { packages: packages, mapsApiKey: mapsApiKey });
            window.google.charts.setOnLoadCallback(function () {
              _this.isLoaded = true;
              _this.isLoading = false;
              resolve();
            });
          }
        });
      });

      return this.initPromise;
    }
  }]);
  return GoogleChartLoader;
}();

exports.default = new GoogleChartLoader();
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Chart/google-chart-loader.js
// module id = 1966
// module chunks = 1